import React, { useEffect, useRef } from 'react';
import { StaticImage } from 'gatsby-plugin-image';
import styled from 'styled-components';
import { srConfig } from '@config';
import sr from '@utils/sr';
import { usePrefersReducedMotion } from '@hooks';

const StyledAboutSection = styled.section`
  max-width: 900px;

  .inner {
    display: grid;
    grid-template-columns: 3fr 2fr;
    grid-gap: 50px;

    @media (max-width: 768px) {
      display: block;
    }
  }
`;
const StyledText = styled.div`
  ul.skills-list {
    display: grid;
    grid-template-columns: repeat(2, minmax(140px, 200px));
    grid-gap: 0 10px;
    padding: 0;
    margin: 20px 0 0 0;
    overflow: hidden;
    list-style: none;

    li {
      position: relative;
      margin-bottom: 10px;
      padding-left: 20px;
      font-family: var(--font-mono);
      font-size: var(--fz-xs);

      &:before {
        content: '▹';
        position: absolute;
        left: 0;
        color: var(--green);
        font-size: var(--fz-sm);
        line-height: 12px;
      }
    }
  }
`;
const StyledPic = styled.div`
  position: relative;
  max-width: 300px;

  @media (max-width: 768px) {
    margin: 50px auto 0;
    width: 70%;
  }

  .wrapper {
    ${({ theme }) => theme.mixins.boxShadow};
    display: block;
    position: relative;
    width: 100%;
    border-radius: var(--border-radius);
    background-color: var(--green);

    &:hover,
    &:focus {
      outline: 0;

      &:after {
        top: 15px;
        left: 15px;
      }

      .img {
        filter: none;
        mix-blend-mode: normal;
      }
    }

    .img {
      position: relative;
      border-radius: var(--border-radius);
      mix-blend-mode: multiply;
      filter: grayscale(100%) contrast(1);
      transition: var(--transition);
    }

    &:before,
    &:after {
      content: '';
      display: block;
      position: absolute;
      width: 100%;
      height: 100%;
      border-radius: var(--border-radius);
      transition: var(--transition);
    }

    &:before {
      top: 0;
      left: 0;
      background-color: var(--navy);
      mix-blend-mode: screen;
    }

    &:after {
      border: 2px solid var(--green);
      top: 20px;
      left: 20px;
      z-index: -1;
    }
  }
`;

const About = () => {
  const revealContainer = useRef(null);
  const prefersReducedMotion = usePrefersReducedMotion();

  useEffect(() => {
    if (prefersReducedMotion) {
      return;
    }

    sr.reveal(revealContainer.current, srConfig());
  }, []);

  const skills = ['Python', 'SQL/dbt', 'Power BI', 'Tableau', 'Excel'];

  return (
    <StyledAboutSection id="about" ref={revealContainer}>
      <h2 className="numbered-heading">About Me</h2>

      <div className="inner">
        <StyledText>
          <div>
            <p>
            Welcome! I'm a data analyst with experience transforming operational and healthcare data into clear, actionable insights that support business decision-making. I enjoy analysing trends, improving reporting visibility, and helping teams better understand performance through effective dashboards and KPI reporting.
            </p>

            <p>
              
            </p>

            <p>
           My background includes working with large operational datasets, validating data accuracy, and collaborating with stakeholders to improve reporting processes and support data-driven decisions. I’m particularly interested in business analytics, operational performance, and turning complex information into practical insights that people can actually use.
            </p>

            <p>I work primarily with {' '} <a href="https://www.udemy.com/certificate/UC-1f3e4975-def6-4c2e-b98b-0db9f345d38e/">Power BI</a>, Excel, {' '} <a href="https://www.udemy.com/certificate/UC-ba7534fa-ab42-4277-9e42-a1af94959b2f/">SQL</a>, {' '} <a href="https://www.udemy.com/certificate/UC-f8e658a8-d4e0-422e-ad91-a9561ab193d0/">Tableau</a>, and {' '} <a href="https://www.udemy.com/certificate/UC-c9b42415-2208-4af5-a5bc-708e177a7ef1/">Python</a> to support reporting, analysis, and visualisation projects. I value clear communication, continuous improvement, and a thoughtful approach to problem-solving.

            </p>

            <p>
              
            </p>

            <p>
           Here are a few technologies I’ve been working with recently
            </p>
          </div>

          <ul className="skills-list">
            {skills && skills.map((skill, i) => <li key={i}>{skill}</li>)}
          </ul>
        </StyledText>

        <StyledPic>
          <div className="wrapper">
            <StaticImage
              className="img"
              src="../../images/me.jpg"
              width={500}
              quality={95}
              formats={['AUTO', 'WEBP', 'AVIF']}
              alt="Headshot"
            />
          </div>
        </StyledPic>
      </div>
    </StyledAboutSection>
  );
};

export default About;
